module.exports = __webpack_public_path__ + "static/9-5f595e3765ca821231e11db99e476768.png";